import { ListItemButton, Typography } from '@mui/material';
import React, { useCallback } from 'react';
import { getSbefCodeFromElementOrRecipe } from '@shared/helpers/sbef.helpers';
import { IElement } from '@shared/models/project.model';
import { Recipe } from '@shared/models/recipe.model';
import SBEFLabel from '@client/pages/components/SBEFLabel';
import { useLastSelectedRecipe } from '@client/store/recipe/recipe.hook';
import {
  LIST_ITEM_HEIGHT,
  LIST_SPACING,
  Row,
  RowCell,
  RowProps,
} from '@ui/ElementList';
import { useApplyRecipe } from '../../../../use-recipes.hooks';

interface RecipeListItemProps extends RowProps {
  recipe: Recipe;
  element: IElement;
  onSelect: () => void;
}

const RecipeListItem: React.FC<RecipeListItemProps> = ({
  recipe,
  element,
  onSelect,
  ...rowProps
}) => {
  const { addRecipeToLastSelected } = useLastSelectedRecipe();
  const applyRecipe = useApplyRecipe();
  const sbefCode = getSbefCodeFromElementOrRecipe(recipe);

  const selectRecipe = useCallback(async () => {
    onSelect();
    if (recipe.id === element.recipe_id) return;

    const updatedElement = await applyRecipe(element, recipe.id);
    if (!updatedElement) return;

    addRecipeToLastSelected(recipe.id);
  }, [applyRecipe, element, recipe.id, onSelect, addRecipeToLastSelected]);

  return (
    <Row
      {...rowProps}
      padding
      height={LIST_ITEM_HEIGHT}
      spacing={LIST_SPACING.DEFAULT}
      selected={recipe.id === element.recipe_id}
    >
      <ListItemButton
        onClick={selectRecipe}
        disableRipple={recipe.id === element.recipe_id}
      >
        <RowCell>
          <SBEFLabel code={sbefCode} />
          <Typography>{recipe.name}</Typography>
        </RowCell>
      </ListItemButton>
    </Row>
  );
};

export default RecipeListItem;
